import Proxy from "./Proxy";

class SettingProxy extends Proxy {
  /**
   * Constructor for Auth proxy
   */
  constructor() {
    super(`/settings`);
  }

  public executeScheduler(data: any) {
    return this.submit("post", `${this.endpoint}/executeschedule`, undefined, data);
  }

  public getScheduledHistory(data: any) {
    return this.submit("get", `${this.endpoint}/schedules`, {filter: JSON.stringify(data)});
  }


}

export default SettingProxy;
